/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ngf-tester-navigation-sidebar-logo',
  standalone: true,
  templateUrl: './tester-navigation-sidebar-logo.component.html',
  styleUrls: ['./tester-navigation-sidebar-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TesterNavigationSidebarLogoComponent {}
